import { render, staticRenderFns } from "./MicroserviceAutocomplete.vue?vue&type=template&id=898fd534&scoped=true&"
import script from "./MicroserviceAutocomplete.vue?vue&type=script&lang=js&"
export * from "./MicroserviceAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898fd534",
  null
  
)

export default component.exports